/* eslint-disable prettier/prettier */
function CaseStudyGate() {
	const gateContainer = document.getElementById('case-study-gate');
	const postContainer = document.getElementById('case-study-post');
	const gateCookie = getCookie("case-study-gated") ? true : false;

    function getCookie(cName) {
        const name = cName + "=";
        const cDecoded = decodeURIComponent(document.cookie); //to be careful
        const cArr = cDecoded .split('; ');
        let res;
        cArr.forEach(val => {
            if (val.indexOf(name) === 0) res = val.substring(name.length);
        })
        return res;
  }

	if (gateContainer && postContainer) {
		if (gateCookie) {
			gateContainer.style.display = 'none';
			postContainer.style.display = 'block';
		} else {
			postContainer.style.display = 'none';
			gateContainer.style.display = 'block';
		}
	}
}

export default CaseStudyGate;
